import { Colors, FontStyleEnums } from '@oy/uicore';
import classNames from 'classnames';
import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  ReactNode,
} from 'react';
import { makeId } from '../../../../utilities/idComponent';
import { Text } from '../../../Contents';
import { Spacer } from '../../../Layout';
import Icon from './Icon';
import styles from './Radio.module.css';

type RadioProps = {
  description?: string | React.ReactNode;
  title: string;
  additionalTitle?: ReactNode;
  titleStyle?: FontStyleEnums;
  descriptionStyle?: FontStyleEnums;
  isDisabled?: boolean;
  additionalInput?: React.ReactNode;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

function Radio({
  checked,
  description,
  title,
  additionalInput,
  additionalTitle,
  titleStyle = FontStyleEnums.BodyMdRegular,
  descriptionStyle = FontStyleEnums.BodyMdRegular,
  isDisabled = false,
  id,
  ...props
}: RadioProps) {
  return (
    <div>
      <label style={{ width: '100%', display: 'initial' }}>
        <div
          className={classNames(styles.container, {
            [styles.alignCenter]: !description && !additionalInput,
          })}
          id={makeId('radioContainer', title, id)}
        >
          <input
            type="Radio"
            className={styles.hiddenRadio}
            alt={title}
            checked={checked}
            {...props}
            disabled={isDisabled}
            id={makeId('radio', title, id)}
          />
          <div className={styles.icon}>
            <Icon
              selected={checked}
              isDisabled={isDisabled}
              id={makeId('radioIcon', title, id)}
            />
          </div>
          <Spacer left={Spacer.Size.S}>
            <Text
              textStyle={titleStyle}
              color={isDisabled ? Colors.BLACK40 : Colors.BLACK100}
            >
              {title}
              {additionalTitle}
            </Text>
            {description && (
              <Spacer top={Spacer.Size.XXXS}>
                <Text
                  textStyle={descriptionStyle}
                  color={isDisabled ? Colors.BLACK40 : Colors.BLACK100}
                >
                  {description}
                </Text>
              </Spacer>
            )}
            {additionalInput && (
              <Spacer top={Spacer.Size.XXXS}>{additionalInput}</Spacer>
            )}
          </Spacer>
        </div>
      </label>
    </div>
  );
}

export default Radio;
